import api from "@/shared/services/api";
import {
  getEmptyPaymentIndicators,
  PaymentIndicators,
  PaymentListParams,
  PaymentListResult,
  PaymentRow,
} from "../types/paymentList.types";

const mapPaymentRow = (row: any): PaymentRow => ({
  id: row.id,
  userId: row.userId ?? "",
  clientId: row.clientId,
  fecha: row.fecha,
  monto: row.monto ?? row.amountUsd ?? 0,
  amountUsd: row.amountUsd ?? row.monto ?? 0,
  rate: row.rate ?? 0,
  amountVef: row.amountVef ?? 0,
  cliente: row.cliente ?? "",
  reference: String(row.reference ?? "").slice(-8),
  esDeTercero: Boolean(row.esDeTercero),
  status: row.status ?? "",
  statusName: row.statusName ?? row.status ?? "-",
  errorMessage: row.errorMessage,
});

const normalizeIndicators = (value: any): PaymentIndicators => {
  const empty = getEmptyPaymentIndicators();
  const data = value || {};

  return {
    total: data.total || empty.total,
    pending: data.pending || empty.pending,
    confirmed: data.confirmed || empty.confirmed,
    rejected: data.rejected || empty.rejected,
    error: data.error || empty.error,
    confirmedAmountUsd: data.confirmedAmountUsd || empty.confirmedAmountUsd,
    confirmedAmountVef: data.confirmedAmountVef || empty.confirmedAmountVef,
  };
};

type PaymentListServiceEndpoints = {
  list: string;
  statistics: string;
};

const defaultEndpoints: PaymentListServiceEndpoints = {
  list: "/operation/payments-list",
  statistics: "/operation/payments-statistics",
};

const createPaymentListService = (endpoints = defaultEndpoints) => ({
  async getPayments(params: PaymentListParams): Promise<PaymentListResult> {
    const response = await api.get(endpoints.list, { params });
    const data = Array.isArray(response.data?.data) ? response.data.data : [];

    return {
      data: data.map(mapPaymentRow),
      totalCount: response.data?.totalCount ?? 0,
    };
  },

  async getStatistics(
    params: PaymentListParams = {},
  ): Promise<PaymentIndicators> {
    const response = await api.get(endpoints.statistics, { params });
    return normalizeIndicators(response.data?.data || response.data || {});
  },
});

const paymentListService = createPaymentListService();

export const creditLinePaymentListService = createPaymentListService({
  list: "/credit-line/operation/payments-list",
  statistics: "/credit-line/operation/payments-statistics",
});

export type PaymentListService = typeof paymentListService;

export default paymentListService;
